import React, { useState } from 'react';
import Icon from 'components/AppIcon';

export default function ForgotPasswordModal({ onClose, onToast }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (!email?.trim()) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      onToast?.('Password reset link sent — please check your inbox.');
      onClose?.();
    }, 900);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: 'rgba(15,23,42,0.55)' }}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-colors"
        >
          <Icon name="X" size={16} />
        </button>
        <div className="mb-6">
          <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-4" style={{ background: 'rgba(59,76,76,0.08)' }}>
            <Icon name="KeyRound" size={20} color="var(--color-primary, #3b4c4c)" />
          </div>
          <h2 className="font-heading text-xl font-semibold text-slate-900 mb-1">Reset your password</h2>
          <p className="text-sm text-slate-500 font-caption">Enter your email address and we'll send you a reset link.</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-semibold text-slate-600 font-caption mb-1.5">Email address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e?.target?.value)}
              placeholder="you@institution.com"
              required
              className="w-full px-4 py-2.5 rounded-xl border border-slate-200 text-sm font-caption text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:border-transparent transition-all"
              style={{ '--tw-ring-color': 'rgba(59,76,76,0.3)' }}
            />
          </div>
          <button
            type="submit"
            disabled={loading || !email?.trim()}
            className="w-full py-2.5 rounded-xl text-sm font-semibold font-caption text-white transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
            style={{ background: 'var(--color-primary, #3b4c4c)' }}
          >
            {loading ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
      </div>
    </div>
  );
}
